export enum OverlayLayer {
  Background = 10,
  Normal = 20,
  Foreground = 30
}